const GUIDE_BASE_URL = 'https://docs.clobe.ai';

// Getting Started
export const PRICING_GUIDE_LINK = `${GUIDE_BASE_URL}/getting-started/pricing`;
export const MULTI_CORPORATION_GUIDE_LINK = `${GUIDE_BASE_URL}/getting-started/multi-corporation-guide`;
export const SECURITY_CENTER_GUIDE_LINK = `${GUIDE_BASE_URL}/getting-started/security-center`;
export const REFERRAL_EVENT_GUIDE_LINK = `${GUIDE_BASE_URL}/getting-started/referral-event`;

// Data Connect
export const DATA_MANAGE_GUIDE_LINK = `${GUIDE_BASE_URL}/data-connect/organization`;
export const LOCATE_CERTIFICATE_GUIDE_LINK = `${GUIDE_BASE_URL}/data-connect/how-to-locate-certificate`;
export const DATA_COLLECTION_POLICY_GUIDE_LINK = `${GUIDE_BASE_URL}/data-connect/data-collection-policy-guide`;
export const INITIAL_ANALYSIS_ERROR_GUIDE_LINK = `${GUIDE_BASE_URL}/data-connect/initial-analysis-error-guide`;
export const CERTIFICATE_RENEWAL_TROUBLESHOOTING_GUIDE_LINK = `${GUIDE_BASE_URL}/data-connect/certificate-renewal-troubleshooting`;

// Team Management
export const COMPANY_MANAGEMENT_GUIDE_LINK = `${GUIDE_BASE_URL}/team-management/company-management-guide`;
export const MEMBERS_GUIDE_LINK = `${GUIDE_BASE_URL}/team-management/members-guide`;
export const ROLES_GUIDE_LINK = `${GUIDE_BASE_URL}/team-management/roles`;

// Notifications
export const DAILY_REPORT_GUIDE_LINK = `${GUIDE_BASE_URL}/notifications/daily-report-guide`;
export const KEYWORD_ALERT_GUIDE_LINK = `${GUIDE_BASE_URL}/notifications/keyword-alert-guide`;

// Labelling
export const LABEL_TYPES_USAGE_GUIDE_LINK = `${GUIDE_BASE_URL}/labelling/label-types-usage`;
export const TRANSACTIONS_GUIDE_LINK = `${GUIDE_BASE_URL}/labelling/bank-transaction-labeling`;
export const CARD_BILLING_LABELING_GUIDE_LINK = `${GUIDE_BASE_URL}/labelling/card-bill-labeling`;
export const BULK_LABELING_GUIDE_LINK = `${GUIDE_BASE_URL}/labelling/bulk-labeling-guide`;
export const ACCOUNT_CLASSIFICATION_GUIDE_LINK = `${GUIDE_BASE_URL}/labelling/account-classification-guide`;

// Evidence
export const EVIDENCE_MAPPING_GUIDE_LINK = `${GUIDE_BASE_URL}/evidence/evidence-mapping-guide`;
export const ISSUE_CANCEL_GUIDE_LINK = `${GUIDE_BASE_URL}/evidence/issue-cancel-guide`;
export const N_TO_ONE_MAPPING_GUIDE_LINK = `${GUIDE_BASE_URL}/evidence/n-to-one-mapping`;

// Settlement
export const RECEIVABLES_PAYABLES_GUIDE_LINK = `${GUIDE_BASE_URL}/settlement/receivables-payables-guide`;
export const SETTLEMENT_VS_GUIDE_LINK = `${GUIDE_BASE_URL}/settlement/vs`;

// Reporting
export const PROFIT_ANALYSIS_GUIDE_LINK = `${GUIDE_BASE_URL}/reporting/profit-analysis-guide`;

// Policy
export const FOREIGN_CURRENCY_GUIDE_LINK = `${GUIDE_BASE_URL}/policy/foreign-currency-guide`;

// Partner
export const ACCOUNTING_FIRM_GUIDE_LINK = `${GUIDE_BASE_URL}/partner/accounting-firm-guide`;
